var map = {
	"./qualification1.png": 1150,
	"./qualification10.png": 4284,
	"./qualification2.png": 8501,
	"./qualification3.png": 9404,
	"./qualification4.png": 9571,
	"./qualification5.png": 1994,
	"./qualification6.png": 2161,
	"./qualification7.png": 4296,
	"./qualification8.png": 6559,
	"./qualification9.png": 230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 505;